import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { AppService } from '../../services/app.service';
import { ToastrService } from 'ngx-toastr';
import { ExcelService } from '../../services/excel.service';
import { HistoriquesComponent } from '../historiques/historiques.component';
import { ReportingOfaService } from 'src/app/content/pages/campagne/reporting-ofa/data-access/reporting-ofa.service';

@Component({
  selector: 'app-historiques-wrapper',
  templateUrl: 'historiques-wrapper.component.html',
  styles: [`
        ::placeholder {
            color: #000;
        }
    `]
})

export class HistoriquesWrapperComponent implements OnInit {
  @Input() listHistorique: any[];
  @Output() pageChange = new EventEmitter<number>();

  public response: any;
  public p = 1;
  public date_debut: string;
  public date_fin: string;
  public _agent: any;
  public filter: string;
  public listAgent: any = [];
  tableFields = {
    historique: [
      { header: '#', width: '1%', field: 'index' },
      { header: 'Date', width: '15%', field: 'created_at' },
      { header: 'Opération', width: '20%', field: 'sous_module' },
      { header: 'Détails opération', width: '40%', field: 'action' },
      { header: 'Source [Utilisateur]', width: '15%', field: 'nom_prenoms' },
      { header: 'Actions', width: '5%', field: 'actions' },
    ],
    details: [
      // { header: '#', width: '1%', field: 'index' },
      { header: 'Champs', width: '30%', field: 'champs' },
      { header: 'Valeurs avant', width: '20%', field: 'valeurs_avant' },
      { header: 'Valeurs après', width: '20%', field: 'valeurs_apres' },
      { header: 'Modification', width: '5%', field: 'actions' },
    ]
  }

  constructor(
    public activeModal: NgbActiveModal,
    public loadingBar: LoadingBarService,
    public toastrService: ToastrService,
    private excelService: ExcelService,
    public reportingSce: ReportingOfaService,
    private modalService: NgbModal,
    public _service: AppService,
  ) { }

  public ngOnInit(): void {
    // this.getHistorique();
    this.reportingSce.historique$.subscribe(
      historique => this.listHistorique = historique
    );
  }

  public showHistorique(data: any) {
    const dataFromJson = data?.data
    const modalRef = this.modalService.open(HistoriquesComponent, { size: 'lg', windowClass: 'custom-modal', centered: true });
    modalRef.componentInstance.tableFields = this.tableFields?.details;
    modalRef.componentInstance.rowData = data;
    if (data.event == "Mise à jour") {
      modalRef.componentInstance.vue = "Mise à jour";
      modalRef.componentInstance.listeOfKeys = [Object.keys(JSON.parse(dataFromJson)['before'])];
    } else {
      modalRef.componentInstance.vue = "CréationOREvenement"
      modalRef.componentInstance.listeOfKeys = [Object.keys(JSON.parse(dataFromJson))];
    }
  }

  onPageChange(event: number) {
    this.p = event;
    this.pageChange.emit(event);
  }


  public exportXls(data, tableFields): void {
    const competenceData = [];
    for (var i = 0; i < data?.length; i++) {
      const agent = {};
      for (const field of tableFields) {
        if (field.field !== 'actions' && field.field !== 'index') {
          agent[field.header] = data[i][field?.field];
        }
      }
      competenceData.push(agent);
    }
    this.excelService.exportAsExcelFile(competenceData, 'Liste des historiques');
  }

}
